import { PACKAGE_TYPE, CONTRACTABLE_BUFFER } from "@/lib/constants";
import { gql } from "@apollo/client";
import { values, taxCalculation, isDateRangeIn } from "./helper";
export const typeDef = gql`
  type Right {
    id: ID!
    name: String!
    exercise_term: Int
    exercise_term_unit: Int
    view_term: Int
    view_term_unit: Int
    view_limit_date: String
    validity_start_at: String
    validity_end_at: String
    price: Int
    discount_price: Int
    isSvod: Boolean
    push_rank: Int
    package_type: Int
    discount_description: String
    contractAllowed: Boolean
    rights_control_type: Int
  }
`;
export const resolvers = {
  Right: {
    id: right => parseInt(right.id || right.right_id, 10),
    price: obj => taxCalculation(values(obj, "price")),
    discount_price: obj => taxCalculation(values(obj, "discount_price")),
    isSvod: obj => PACKAGE_TYPE["svod"] == values(obj, "package_type"),
    package_type: obj => values(obj, "package_type"),
    push_rank: obj => values(obj, "push_rank"),
    discount_description: obj => values(obj, "discount_description"),
    contractAllowed: right => {
      if (right) {
        var _right$values, _right$values2;
        return isDateRangeIn(right === null || right === void 0 || (_right$values = right.values) === null || _right$values === void 0 ? void 0 : _right$values.delivery_start_date, right === null || right === void 0 || (_right$values2 = right.values) === null || _right$values2 === void 0 ? void 0 : _right$values2.delivery_end_date, {
          buffer: CONTRACTABLE_BUFFER,
          default: true
        });
      }
      return false;
    },
    rights_control_type: obj => values(obj, "rights_control_type")
  }
};